import React from 'react'
import Stack from '@mui/material/Stack'
import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'
import FileUploadIcon from '@mui/icons-material/FileUpload'
import FileDownloadIcon from '@mui/icons-material/FileDownload'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'

export interface ListIconActionsProps {
  onImport: () => void
  onExport: () => void
  exporting?: boolean
  showDeleted: boolean
  onToggleDeleted: () => void
}

export const ListIconActions: React.FC<ListIconActionsProps> = ({
  onImport,
  onExport,
  exporting = false,
  showDeleted,
  onToggleDeleted,
}) => (
  <Stack direction="row" spacing={0.25}>
    <Tooltip title="Import">
      <IconButton size="small" aria-label="Import" onClick={onImport}>
        <FileUploadIcon fontSize="small" />
      </IconButton>
    </Tooltip>
    <Tooltip title="Export">
      {/* span keeps tooltip reachable while the button is disabled */}
      <span>
        <IconButton
          size="small"
          aria-label="Export"
          onClick={onExport}
          disabled={exporting}
        >
          <FileDownloadIcon fontSize="small" />
        </IconButton>
      </span>
    </Tooltip>
    <Tooltip title={showDeleted ? 'Hide deleted' : 'Show deleted'}>
      <IconButton
        size="small"
        aria-label="Show deleted"
        color={showDeleted ? 'primary' : 'default'}
        onClick={onToggleDeleted}
      >
        <DeleteOutlineIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  </Stack>
)
